/**
 * Created by amirb on 5/31/16.
 */

define(function (require) {

    window.lpTag = window.lpTag || {};

    var lpUtils = require('utils/lpUtils');
    var Bubble = require("ui/bubble/Bubble");
    var ChatLineStateBubbleView = require("web-agent-views/ChatLineStateBubbleView");
    var ViewController = require('web-agent-framework/ViewController');
    var MESSAGE_STATES = lpTag.AMSStatics.messageState;
    var DELETED = '*** LP deleted data ***';

    var ChatLineImageViewController = ViewController.extend({
        ControllerName:'ChatLineImageViewController',
        chatLineState: {

        },

        LPViewMap:{


        },
        LPClassesMap: {
            container: '.lpview_img_preview',
            image: '.lpview_image_thumbnail',
            strip: '.lpview_strip',
            downloadButton: '.download_img',
            loader: '.lp_file_loader',
            uploadError: '.lp_image_sharing_upload_error_overlay',
            retryUpload: '.lp_retry_photo_upload',
            failedUpload: '.lp_failed_photo_upload',
            defaultImage: '.default_image'
        },
        initialize:function (constructorData) {
            this.currentView = constructorData.lineView;
            this.squenceId = constructorData.squenceId;
            this.convId = constructorData.convId;
            this.modelController = constructorData.modelController;
            this.rowData = constructorData.data;
            this.rowData = this.rowData.event ? this.rowData.event : this.rowData;
            this.rowData.conversationId =  constructorData.convId;
            this.rowData.latestAgentId =  constructorData.data.latestAgentId;
            this.rowData.id =  constructorData.data.id;
            this.isFeatureEnabled = constructorData.isFeatureEnabled;
            this.isHistory = constructorData.data.isHistory;
            this.verificationId = constructorData.data.verificationId;
            this.consumerId = this.modelController.getModelParam('chats.' + this.convId +'.visitorInfo.visitorId');
            this.agentId = this.modelController.getModelParam('agent.messagingUserId');
            this.initView();
        },

        events:function () {
            this.bindViewEvent({selector : this.LPClassesMap.image, DOMEvent : "click", callback : this.openImageDisplay,inView:this.currentView});
            this.bindViewEvent({selector : this.LPClassesMap.defaultImage, DOMEvent : "click", callback : this.openImageDisplay,inView:this.currentView});
            this.bindViewEvent({selector : this.LPClassesMap.downloadButton, DOMEvent : "click", callback : this.downloadImage,inView:this.currentView});
            if (this.verificationId) {
                // If there's a verification ID - it's a line that we're sending, so we need to keep track of its state
                this.viewEventsHandler.bindEvent({
                    appName: this.verificationId,
                    UIEvent: this.eventType.SHOW_FILE_UPLOAD_ERROR,
                    callback: this.updateUploadState
                });
                this.bindModel({modelPath: 'chats.' + this.convId + '.chatInfo.events.event', callback: this.updateLineIdAndState});
                this.bindModel({modelPath: 'chats.' + this.convId + '.chatInfo.linesState.' + this.verificationId, callback: this.updateLineState});
            }
        },

        render:function () {
        }
    });

    ChatLineImageViewController.prototype.initView = function(){
        var listTemplate = require('web-agent-templates/LP_image_chat_line.html');
        var preview = this.rowData.message ? this.rowData.message.preview : this.rowData.preview;
        if (preview === DELETED || (this.rowData.message && this.rowData.message.relativePath && this.rowData.message.relativePath === DELETED)) {
            this.isFeatureEnabled = false;
        }
        if (this.isFeatureEnabled) {
            listTemplate = this.injectTextDefaults(listTemplate, {
                imagePreview: preview,
                lineId: this.verificationId
            });
        }

        var view =  this.createView({template: listTemplate, wrapWithDiv: false});
        this.addView({viewToAdd : view, targetView : this.currentView,beforeView:this.currentView.firstChild});

        this.container = this.getFirstElement(this.LPClassesMap.container, this.currentView);
        this.imageElement = this.getFirstElement(this.LPClassesMap.image, this.currentView);
        this.strip = this.getFirstElement(this.LPClassesMap.strip, this.currentView);
        this.defaultImage = this.getFirstElement(this.LPClassesMap.defaultImage, this.currentView);

        if (!this.isFeatureEnabled) {
            this.lpHide(this.strip);
            this.lpHide(this.imageElement);
        } else if (!preview || preview === 'null') {
            this.lpHide(this.imageElement);
            this.addClass(this.defaultImage, 'enabled');
        } else {
            this.lpHide(this.defaultImage);
        }
        this.loader = this.getFirstElement(this.LPClassesMap.loader, this.currentView);
        this.uploadErrorElement = this.getFirstElement(this.LPClassesMap.uploadError, this.currentView);
    };
    ChatLineImageViewController.prototype.downloadImage = function(){
        var data =  this.rowData;
        this.modelController.getDownloadUrl({
            conversationId: data.conversationId,
            pathUrl:data.message.relativePath,
            index:this.currentIndex,
            id:data.id,
            done: this.openFileDownloadDialog.bind(this),
            lastUrl: this.lastUrl,
            isHistory:this.isHistory
        });
    };

    ChatLineImageViewController.prototype.openFileDownloadDialog = function(data) {
        if (this.isFeatureEnabled) {
            window.open(data.url, '_blank');
            this.lastUrl = data.url;
        }
    };

    ChatLineImageViewController.prototype.updateUploadState = function(data) {
        data = (data && data.newValue && data.newValue.eventData) || data || {};

        this.uploadErrorElement.removeAttribute('role');
        if(!data.showLoader && data.error) {
            if (!data.canRetry) {
                this.uploadErrorElement.onclick = null;
                delete this.uploadErrorElement.onclick;
            } else {
                this.uploadErrorElement.onclick = this.retry.bind(this);
                this.uploadErrorElement.setAttribute('role', 'button');
            }
        }
    };

    ChatLineImageViewController.prototype.retry = function() {
        if (this.verificationId) {
            this.modelController.retryUploadFile({id: this.verificationId});
        }
    };

    ChatLineImageViewController.prototype.updateLineIdAndState = function(data) {
        if (data && data.newValue && data.newValue.length > 0 && !this.rowData.id) {
            for (var i = 0; i < data.newValue.length; i++) {
                var update = data.newValue[i];
                if (update.verificationId === this.verificationId && update.id) {
                    this.rowData.id = update.id;
                    this.unbindModel({modelPath: 'chats.' + this.convId + '.chatInfo.events.event', callback: this.updateLineIdAndState});
                    this.finishedLoading();
                    break;
                } else if (update.verificationId === this.verificationId && update.failed) {
                    this.unbindModel({modelPath: 'chats.' + this.convId + '.chatInfo.events.event', callback: this.updateLineIdAndState});
                    this.showError();
                    break;
                }
            }
        }
    };

    ChatLineImageViewController.prototype.updateLineState = function(data) {
        if (data && data.newValue && data.newValue.status && data.newValue.status === MESSAGE_STATES.NACK) {
            this.showError();
        }
    };

    ChatLineImageViewController.prototype.finishedLoading = function() {
        this.viewEventsHandler.fireEvent({
            appName: this.verificationId,
            UIEvent: this.eventType.SHOW_FILE_UPLOAD_ERROR,
            eventData: {
                showLoader: false,
                error: false,
                canRetry: true
            }
        });
    };

    ChatLineImageViewController.prototype.showError = function() {
        this.viewEventsHandler.fireEvent({
            appName: this.verificationId,
            UIEvent: this.eventType.SHOW_FILE_UPLOAD_ERROR,
            eventData: {
                showLoader: false,
                error: true,
                canRetry: false
            }
        });
    };

    ChatLineImageViewController.prototype.getImageIndex = function(){

    };

    ChatLineImageViewController.prototype.openImageDisplay = function() {
        if (this.isFeatureEnabled) {
            window.App.PhotoPreviewView.showView(this.rowData);
        }
    };
    window.ChatLineImageViewController = ChatLineImageViewController;

    return ChatLineImageViewController;

});
